/*
 * Collection end (docs/theme/CONTINUITY.md#5-collection-end): once the collection has no next page left, put the
 * "More like <collection>" divider and its sibling chips at the end of the grid, then let the shared loader
 * (assets/continue-feed.js) keep the grid going with the next collections from snippets/collection-continue.liquid.
 * When those run out too, a copy of the divider closes the grid.
 *
 * Cards go into the collection's own list, so "View as" applies to them. Each new collection starts with a
 * full-row heading item. The shopper's filters (filter.*) and sort carry over from the URL; without an
 * availability filter only in-stock products load, like the grid (settings.hide_out_of_stock_in_grid).
 *
 * Filter and sort changes re-render #CollectionProductGrid .collection, which brings a fresh, inert root; the
 * observer starts it when that grid also runs out. Infinite scroll (theme.js) replaces the pagination as it goes,
 * so the end is "no [data-infinite-scrolling] link left".
 */
(function () {
    if (window.collectionContinue) return;
    window.collectionContinue = true;

    const SECTION = 'collection-continue-cards';

    const query = () => {
        const params = new URLSearchParams();
        params.set('section_id', SECTION);
        new URLSearchParams(window.location.search).forEach((value, key) => {
            if (key.startsWith('filter.') || key === 'sort_by') params.append(key, value);
        });
        if (!params.has('filter.v.availability')) params.set('filter.v.availability', '1');
        return params.toString();
    };

    const clone = (root, selector) => root.querySelector(selector).content.firstElementChild.cloneNode(true);

    const start = () => {
        const grid = document.getElementById('CollectionProductGrid');
        const root = grid && grid.querySelector('[data-collection-continue]:not([data-feed-ready])');
        if (!root || !window.ContinueFeed || grid.querySelector('.collection [data-infinite-scrolling]')) return;
        const collection = root.closest('.collection');
        const listing = collection && collection.querySelector('.productListing');
        if (!listing) return;

        root.setAttribute('data-feed-ready', '');
        collection.classList.add('is-continuing');
        const end = clone(root, 'template[data-continue-end]');
        listing.appendChild(end);

        // The loader only sees clicks inside its root; these cards live in the grid, after the divider.
        listing.addEventListener('click', (event) => {
            if (typeof window.clarity !== 'function') return;
            const card = event.target.closest('.product a');
            if (card && end.compareDocumentPosition(card) & Node.DOCUMENT_POSITION_FOLLOWING) window.clarity('event', 'collection_continue_click');
            else if (event.target.closest('[data-feed-chip]')) window.clarity('event', 'collection_continue_chip');
        });

        const options = JSON.parse(root.querySelector('script[data-feed-config]').textContent);
        if (!options.sources.length) return;
        options.query = query();
        // The chips again after the last cards; a divider without chips would only be a second rule line.
        options.end = () => {
            const final = clone(root, 'template[data-continue-end]');
            if (final.querySelector('[data-feed-chip]')) listing.appendChild(final);
        };
        options.target = (source) => {
            const heading = clone(root, 'template[data-continue-heading]');
            heading.querySelector('[data-feed-heading]').textContent = source.heading;
            heading.querySelector('[data-continue-all]').href = source.url;
            listing.appendChild(heading);
            return listing;
        };
        new window.ContinueFeed(root, options);
    };

    // continue-feed.js is deferred before this file, so ContinueFeed exists by now.
    start();
    // Batched: a card swap or a popup opening makes hundreds of mutations in a row, and start() ran for each.
    let pending = null;
    new MutationObserver(() => {
        if (!pending) pending = setTimeout(() => { pending = null; start(); }, 100);
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
})();
